import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createGlobalStyle } from 'styled-components';
import { GuidaGlobalStyles } from '@inter-ikea-guida/framework';
import '@inter-ikea-guida/normalize-css';
import 'focus-visible';
const SurveyGlobalStyles = createGlobalStyle `
/* Add pax guide global styling here */

/* 
  Slider styles.
  These are needed because the PAX guide has trouble importing the CSS if imported into the SkapaStyles as is intended, i.e we do not add the line import '@ingka/slider/dist/style.css in the SkapaStyles.ts.
  Feel free to investigate this further, but there is no way to test this for us without deploying the guida module inside the PAX guide, so proceed with caution!
*/
.slider {
  position: relative;
  margin-bottom: 1.25rem;
}
.slider__controls {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.slider__label {
  font-size: 1rem;
  line-height: 1.5;
}
.slider__label-dbm {
  padding-bottom: 0.5rem;
}
.slider-disabled .slider__label {
  color: rgb(var(--colour-interactive-disabled-1, 223, 223, 223));
}
.slider-drag .slider-tooltips .slider-tooltip {
  transition: none;
}
.slider .slider__input-fields {
  margin-bottom: 0.0625rem;
  align-self: flex-end;
}
.slider__input-fields input {
  padding-top: 0;
}
.slider__input-fields .input-field__wrapper {
  width: 4.5rem;
}
.slider .form-field {
  margin-bottom: 0;
}
.slider .form-field__content {
  margin-top: 0.5rem;
}
.slider__input--m .input-field__wrapper {
  width: 5.5rem;
}
.slider__input--l .input-field__wrapper {
  width: 6.5rem;
}
.slider--dual-sliders .slider__controls {
  flex-direction: column;
  align-items: stretch;
}
.slider--dual-sliders .slider__input-fields {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.slider--with-input .slider-target {
  margin-top: 2.125rem;
}

/*! nouislider - 14.0.2 - 6/28/2019 */
/* Functional styling;
* These styles are required for nouislider to function.
* You don"t need to change these rules to apply your design.
*/
.slider-target,
.slider-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(var(--colour-neutral-7, 17, 17, 17), 0);
  -webkit-user-select: none;
  -ms-touch-action: none;
  touch-action: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.slider-target {
  position: relative;
  margin-top: 3.375rem;
}

.slider-base::after {
  content: " ";
  height: 2.75rem;
  width: 100%;
  position: absolute;
  cursor: pointer;
  top: -1.375rem;
}

.slider-base,
.slider-connects,
.slider-tooltips {
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 1;
}

.slider-base,
.slider-tooltips {
  cursor: pointer;
  margin: 0px 0.75rem;
  width: calc(100% - 1.5rem);
}

.slider-tooltips {
  position: absolute;
  pointer-events: none;
}
.slider-tooltips .slider-tooltip {
  transition: left 200ms cubic-bezier(0.4, 0, 0.4, 1);
  transition-property: left, right;
}

/* Wrapper for all connect elements.
*/
.slider-connects {
  overflow: hidden;
  z-index: 0;
}

.slider-connect,
.slider-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.slider-connect {
  height: 100%;
  width: 100%;
}

.slider-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
*/
.slider-horizontal .slider-origin {
  left: auto;
  right: 0;
}

html[dir=rtl] .slider-rtl .slider-origin {
  left: 0;
  right: auto;
}
html[dir=rtl] .slider-rtl .slider-handle {
  left: -0.75rem;
  right: auto;
}

.slider-horizontal .slider-origin {
  height: 0;
}

.slider-handle {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
}
.slider-handle.slider-active {
  box-shadow: 0 0 0 0.1875rem rgba(var(--colour-neutral-7, 17, 17, 17), 0.1);
}

.slider-touch-area {
  position: relative;
  height: 2.75rem;
  width: 2.75rem;
  left: -0.6875rem;
  top: -0.6875rem;
}

.slider-state-tap .slider-connect,
.slider-state-tap .slider-origin {
  transition: transform 200ms cubic-bezier(0.4, 0, 0.4, 1);
}

.slider-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
*/
.slider-horizontal {
  height: 0.25rem;
  border-radius: 8px;
}

.slider-horizontal .slider-handle {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 64px;
  top: -0.625rem;
  right: -0.75rem;
  left: auto;
}

/* Styling;
* Giving the connect element a border radius causes issues with using transform: scale
*/
.slider-target {
  background: rgb(var(--colour-neutral-3, 223, 223, 223));
}

.slider-connects {
  border-radius: 8px;
  --skapa-slider-connection-colour: rgb(var(--colour-neutral-7, 17, 17, 17));
  position: absolute;
  left: -0.75rem;
  width: calc(100% + 1.5rem);
}
[disabled] .slider-connects {
  --skapa-slider-connection-colour: rgb(var(--colour-interactive-disabled-1, 223, 223, 223));
}

.slider--marks .slider-base {
  background-position: left center;
  background-image: linear-gradient(90deg, rgba(var(--colour-neutral-7, 17, 17, 17), 0.15), 0.125rem, transparent, 0, transparent);
  background-size: max((100% - 0.125rem) / var(--skapa-slider-step-count, 10), 0.125rem) 100%;
}
.slider--marks .slider-connects::after {
  position: absolute;
  z-index: 3;
  content: "";
  top: 0;
  bottom: 0;
  left: 0.75rem;
  right: 0.75rem;
  background-position: left center;
  background-image: linear-gradient(90deg, rgba(var(--colour-neutral-1, 255, 255, 255), 0.35), 0.125rem, transparent, 0, transparent);
  background-size: max((100% - 0.125rem) / var(--skapa-slider-step-count, 10), 0.125rem) 100%;
  clip-path: inset(0% calc(100% - var(--skapa-slider-handle-value-0, 0%)) 0% 0%);
}
.slider--marks.slider--dual-sliders .slider-connects::after {
  clip-path: inset(0% calc(100% - var(--skapa-slider-handle-value-1, 0%)) 0% var(--skapa-slider-handle-value-0, 0%));
}

.slider-connect {
  background: var(--skapa-slider-connection-colour);
}

/* Handles and cursors;
*/
.slider-draggable {
  cursor: ew-resize;
}

.slider-handle {
  background: rgb(var(--colour-neutral-7, 17, 17, 17));
  cursor: grab;
}

.slider-active {
  cursor: grabbing;
}

/* Disabled state;
*/
[disabled] .slider-connect {
  background: rgb(var(--colour-interactive-disabled-1, 223, 223, 223));
}

[disabled].slider-target,
[disabled].slider-handle,
[disabled] .slider-handle {
  cursor: not-allowed;
}

/* Base;
*
*/
.slider-pips,
.slider-pips * {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.slider-pips {
  position: absolute;
  color: rgb(var(--colour-neutral-3, 223, 223, 223));
  border-radius: 4px;
}

/* Values;
*
*/
.slider-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
  display: none;
}

.slider-value-sub {
  color: rgb(var(--colour-neutral-4, 204, 204, 204));
  font-size: 0.875rem;
  display: none;
}

/* Markings;
*
*/
.slider-marker {
  position: absolute;
}

/* Tooltip;
*
*/
.slider-tooltip {
  position: absolute;
  display: block;
  border-radius: 4px;
  text-align: center;
  white-space: nowrap;
  background: rgb(var(--colour-neutral-7, 17, 17, 17));
  color: rgb(var(--colour-text-and-icon-5, 255, 255, 255));
  padding: 0.25rem 0.5rem;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.5;
}

/* Horizontal layout;
*
*/
.slider-pips-horizontal {
  height: 0.25rem;
  top: 0;
  left: 12px;
  width: calc(100% - 24px);
}

.slider-pips-horizontal.slider-pips-light {
  left: 0;
  width: 100%;
}
.slider-pips-horizontal.slider-pips-light .slider-marker-horizontal.slider-marker {
  background: rgba(var(--colour-neutral-1, 255, 255, 255), 0.35);
}

.slider-value-horizontal {
  -webkit-transform: translate(-50%, 50%);
  transform: translate(-50%, 50%);
}

.slider-rtl .slider-value-horizontal {
  -webkit-transform: translate(50%, 50%);
  transform: translate(50%, 50%);
}

.slider-marker-horizontal.slider-marker {
  margin-left: -0.125rem;
  width: 0.125rem;
  height: 0.25rem;
  background: rgba(var(--colour-neutral-7, 17, 17, 17), 0.15);
}

.slider-marker-horizontal.slider-marker-sub {
  height: 0.25rem;
}

.slider-marker-horizontal.slider-marker-large {
  height: 0.25rem;
}

.slider-horizontal ~ .slider-tooltips {
  bottom: 0;
}

.slider-horizontal ~ .slider-tooltips .slider-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 1.25rem;
  /* display: none; */
}

.slider-horizontal .slider-active .slider-tooltip {
  display: block;
}

.slider-horizontal .slider-handle.focus-visible .slider-tooltip {
  display: block;
}

.slider-target[disabled] .slider-connect,
.slider-target[disabled] .slider-handle {
  background: rgb(var(--colour-interactive-disabled-1, 223, 223, 223));
}

[disabled].slider-handle {
  background: rgb(var(--colour-interactive-disabled-1, 223, 223, 223));
}

[dir=rtl] .slider {
  --skapa-slider-fill-direction: -90deg;
}
[dir=rtl] .slider-connects::after {
  transform: scaleX(-1);
}
[dir=rtl] .slider .slider-horizontal ~ .slider-tooltips .slider-tooltip {
  left: auto;
  right: 50%;
  transform: translate(50%, 0);
}

/*--- END OF SLIDER STYLES ---*/
  
`;
const GlobalStyles = () => {
    return (_jsxs(_Fragment, { children: [_jsx(GuidaGlobalStyles, {}), _jsx(SurveyGlobalStyles, {})] }));
};
export default GlobalStyles;
//# sourceMappingURL=GlobalStyles.js.map